import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Pagination from '@/components/Pagination'
import 'jquery'
import SvgIcon from '@/components/SvgIcon' // svg component
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './permission.js'
import utils from './mixin/utils'
import Tinymce from '@/components/Tinymce'
import VueClipboard from "vue-clipboard2";
import htmlToPdf from './utils/jspdf';
import { Button,Cell,CellGroup,NavBar } from 'vant';
import VueI18n from 'vue-i18n';
Vue.use(NavBar)
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(VueI18n);
const i18n=new VueI18n({
  locale:localStorage.getItem('languageSet')||'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
  messages:{
    'zh':require('./components/language/zh'),
    'en':require('./components/language/en')
  }
})



Vue.use(htmlToPdf)
// 在组件中可以调用this.getPdf(title, dom)方法导出

Vue.use(VueClipboard);


// import permission from './permission.js'

// import './styles/element-variables.scss'
Vue.component('svg-icon', SvgIcon)
Vue.use(ElementUI, {
  size: 'medium'
})
Vue.component('Tinymce', Tinymce)
Vue.component('pagination', Pagination)
/* eslint-disable */
Vue.use(VueAwesomeSwiper)
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

Vue.mixin(utils)
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js